namespace e5.ScrollViewScale {
    class ScrollViewScaleNone implements IScrollViewScale {
        public getScale(view: ScrollView): number {
            return view.scale;
        }
    }

    export const None = new ScrollViewScaleNone();
}